<template>
  <div class="text-left">
    <p>{{this.parse()}}</p>
  </div>
</template>

<script>
  export default {
    name: 'NumberOrUnlimited',
    props: ['row', 'column'],
    data: () => {
      return {}
    },
    methods: {
      parse() {
        if (!this.row[this.column]
          || isNaN(this.row[this.column])
          || this.row[this.column] <= 0) return "Unlimited";

        return this.row[this.column];
      }
    }
  }
</script>
